import { setSnackbarMessage } from './snackbarAction';
import { isEditingInProgress } from './AppAction';

export const userAddressesFetched = (items) => { 
	return { 
		type: 'USER_ADDRESSES_FETCHED', 
		payload: items 
	}
}


export const userDestroyAddresses = () => { 
	return { 
		type: 'DESTROY_ADDRESSES'		
	}
}



//-- This action fetches the routes based on a user ID
export const getAddressesForUser = (url, user_id, showEditProgress, selectedRepresentativeUserId) => {
	let data = new FormData();

	data.append('user_id', user_id );
	data.append('selectedRepresentativeUserId', selectedRepresentativeUserId)
	return (dispatch) => {
		dispatch(isEditingInProgress('addresses',true));
		fetch(url,
		{
			method: "POST",
			body: data
		})
		.then((response) => {
			if (!response.ok) {
				throw Error(response.statusText);
			}

			return response;
		})
		.then((response) => response.json())
		.then((items) => {

			if(!items.error_message) {
				dispatch(isEditingInProgress('addresses',false));
				dispatch(userAddressesFetched(items))
			}else{
				dispatch(isEditingInProgress('addresses',false));
				dispatch(setSnackbarMessage(items.error_message));
			}

		})
		.catch((exception) => {
			dispatch(isEditingInProgress('addresses',false));
			//dispatch(setSnackbarMessage('Er heeft zich een fout voorgedaan tijdens het laden van uw adressesn'));
		});
	};
}

export const setAddressImage = (obj) => {
	return {
		type: 'SET_ADDRESS_IMAGE',
		payload: obj
	}
}

export const setAddressImageRefreshing = (obj) => {
	return { 
		type: 'SET_ADDRESS_IMAGE_REFRESHING',
		payload: obj
	}
}

export const uploadImage = (url, addressId, image) => {

	let formData = new FormData();
	formData.append('image',image);
	formData.append('address_id', addressId);
	return (dispatch) => {
		dispatch(setAddressImageRefreshing({dp_address_id: addressId, status: true}));
		fetch(url,
        {
            method: 'POST',
            body: formData,
           

        })
        .then((response) => {
            if (!response.ok) {
                throw Error(response.statusText);
            }
            return response;
        })
        .then((response) => response.json())
        .then((items) => {
        
            if(items.flash_message) {
            	dispatch(setSnackbarMessage(items.flash_message));
                if(items.type === 'success') {
                	
					dispatch(setAddressImage({photo: items.data, dp_address_id: addressId}));
					dispatch(setAddressImageRefreshing({dp_address_id: addressId, status: false}));

					dispatch(setSnackbarMessage(items.flash_message));
                }

            }

            dispatch(setAddressImageRefreshing({dp_address_id: addressId, status: false}));
        })
        .catch(() => {
            //dispatch(setSnackbarMessage('Er heeft zich een fout voorgedaan.'));
        });
    }
}




// WEBPACK FOOTER //
// ./src/redux/actions/addressAction.js